import React, { useState } from 'react'
import ImageComponent from '../../../common/Image';
import { useDispatch, useSelector } from 'react-redux';
import { setHdfcAddOnDetails, setSelectedAddOns, setStage, setSubStage, setUserAddOnDetails, stageSubmit } from '../../../../slices/eligibility/eligibilitySlice';
import Loader from '../../../common/Loader';
import { toast } from 'react-toastify';

const DoSummary = () => {
    const dispatch = useDispatch()
    const { emiData } = useSelector(state => state?.eligibility)
    const [loader, setLoader] = useState(false)
    const [modal, setModal] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)

    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');

    const updateData = async () => {
        setLoader(true)
        const response = await dispatch(stageSubmit({ reference_id: referenceId, sub_stage: "do_summary" })).unwrap()
        setLoader(false)
        if (response?.response_code === 'S100') {
            dispatch(setStage("mandate"))
        }
        else if (response?.response_code === 'E332') {
            setModal(false)
            toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        } else {
            !response?.payload?.error &&
                toast.error(response?.response_string || "Something went wrong", {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        }
    }

    const showModal = () => {
        setModal(true)
    }

    console.log(emiData?.hdfc_data, "emiData")

    return (
        <>
            {loader === true && <Loader />}
            <div className="col-md-9 col-sm-12 Side-bank-Right">
                <p className="Pname-i floating-bottom">DO Summary</p>

                <div className="dataView box-linear-shadow row gy-4 mx-auto mt-4 mb-2">
                    <div className="col-12 border-class ps-1">
                        <p className="d-flex justify-content-between"> Product Details<span className=" edit-border" role="button"
                            onClick={() => setConfirmModal('brand')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setConfirmModal('brand');
                                }
                            }}><i className="icon-Contentedit-2"></i></span></p>
                    </div>

                    <div className="col-6 ps-1">
                        <p><label>Model</label>
                            <p>{emiData?.product_info?.toUpperCase()}</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Product Price</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.product_cost).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 ps-1">
                        <p><label>Brand</label>
                            <p>{emiData?.selected_sku?.brand_name}</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Category</label>
                            <p>{emiData?.selected_sku?.category}</p>
                        </p>
                    </div>
                    <div className="col-6 ps-1">
                        <p><label>Margin Money</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.total_margin_money).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Finance Amount</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.revised_finance_amount).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 ps-1"></div>

                    <div className="col-12 border-class ps-1">
                        <p className="d-flex justify-content-between"> Scheme Details<span className=" edit-border" role="button"
                            onClick={() => setConfirmModal('scheme')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setConfirmModal('scheme')
                                }
                            }}><i className="icon-Contentedit-2"></i></span></p>
                    </div>
                    <div className="col-6 ps-1">
                        <p><label>Tenure</label>
                            <p>{emiData?.emi_details?.total_tenure} Months</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Initial Installments</label>
                            <p>{emiData?.emi_details?.advance_emi_tenure} Months</p>
                        </p>
                    </div>
                    <div className="col-6 p-0">
                        <p><label>Net Tenure</label>
                            <p>{emiData?.emi_details?.net_tenure} Months</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Initial Installment Amount</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.advance_emi_amount).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 ps-1">
                        <p><label>EMI</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.emi_amt).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 pe-1 text-end">
                        <p><label>Optional Services EMI</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.cross_sell_emi).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                    <div className="col-6 ps-1">
                        <p><label>Final EMI</label>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.emi_finance_with_cross_sell).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-12 border-class ps-1">
                        <p className="d-flex justify-content-between"> Optional Services<span className=" edit-border" role="button"
                            onClick={() => setConfirmModal('addon')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setConfirmModal('addon')
                                }
                            }}><i className="icon-Contentedit-2"></i></span></p>
                    </div>

                    {emiData?.cross_sell_detail?.map((item, index) => {
                        const baseIndex = 11; // 11 static col-6 elements before this dynamic section
                        const currentPosition = baseIndex + (index * 3);

                        return (
                            <React.Fragment key={index}>
                                <div className={`col-6 ps-1 ${(currentPosition + 1) % 2 === 0 && ''}`}>
                                    <p>
                                        <label>Optional Services</label>
                                        <p>{item.crosssell_name}</p>
                                    </p>
                                </div>
                                <div className={`col-6 ps-1 ${(currentPosition + 2) % 2 === 0 ? '' : 'text-end'}`}>
                                    <p>
                                        <label>Tenure</label>
                                        <p>{item.year} Year</p>
                                    </p>
                                </div>
                                <div className={`col-6 ps-1 ${(currentPosition + 3) % 2 === 0 && ''}`}>
                                    <p>
                                        <label>Optional Services Amount</label>
                                        <p><span className="font-serif me-1">₹</span>{Number(item.crossel_amount).toLocaleString('en-IN')}</p>
                                    </p>
                                </div>

                                <div className={`col-6 ps-1 ${(currentPosition + 2) % 2 === 0 ? '' : 'text-end'}`}></div>
                                {index !== emiData.cross_sell_detail.length - 1 && <hr className='mb-0' />}
                            </React.Fragment>
                        )
                    })}

                    <div className="col-12 border-class ps-1 last-div">
                        <p className="d-flex justify-content-between"> Down Payment and Disbursement</p>
                    </div>

                    <p className="text-secondary ps-1">
                        Customer Down-payment <span className="d-table bracket-text">(Deduction by CIFCL)</span>
                    </p>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Initial Installment Amount</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.advance_emi_amount).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Admin & Processing Fee *</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.processing_fee).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Total Margin Money</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.total_margin_money).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Total Down Payment</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.total_down_payment).toLocaleString('en-IN')}</p>
                        </p>
                    </div>


                    <div className="col-9 ps-1">
                        <p>
                            <label>Interest Payable at Disbursement</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.interest_at_disbursement).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Dealer Subvention Amount *</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.dbd_amt).toLocaleString('en-IN')}</p>
                        </p>
                    </div>

                    <div className="col-9 ps-1">
                        <p>
                            <label>Final Disbursement Amount</label>
                        </p>
                    </div>

                    <div className="col-3 pe-1 text-end">
                        <p>
                            <p><span className="font-serif me-1">₹</span>{Number(emiData?.emi_details?.final_disbusement).toLocaleString('en-IN')}</p>
                        </p>
                    </div>
                </div><span className='ps-1'>(*Incl of GST)</span>
            </div>

            <footer className="sticky-bottom-1">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-end">
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    // disabled={!isChecked}
                                    onClick={() => { setModal(true) }}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {
                modal &&
                <>
                    <div className="modal fade show" id="selfiepopup" tabIndex="-1" aria-labelledby="panCompLabel" style={{ display: "block", paddingLeft: "0px" }} aria-hidden="true">
                        <div className="modal-dialog bottom-modal modal-dialog-scrollable">
                            <div className="modal-content">

                                <div className="custom-padding text-center">
                                    <ImageComponent fileName="2fverify.svg" alt="2fverify" />
                                    <p className="fw-semibold m-0 mt-3">Do you wish to proceed ? Once you proceed you will not be able to change the selected Model, scheme and Optional Services</p>
                                    <div className="d-flex justify-content-between mt-4">
                                        <button className="btn btn-outline-primary px-5" type="button" onClick={() => { setModal(false) }}>No</button>
                                        <button className="btn btn-primary px-5" type="button" onClick={() => { updateData() }}>Yes</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            }
            {
                confirmModal &&
                <>
                    <div className="modal fade show" id="selfiepopup" tabIndex="-1" aria-labelledby="panCompLabel" style={{ display: "block", paddingLeft: "0px" }} aria-hidden="true">
                        <div className="modal-dialog bottom-modal modal-dialog-scrollable">
                            <div className="modal-content">

                                <div className="custom-padding text-center">
                                    <ImageComponent fileName="2fverify.svg" alt="2fverify" />
                                    <p className="fw-semibold m-0 mt-3">Are you sure you want to change the {confirmModal === 'scheme' && 'Scheme' || confirmModal === 'brand' && 'Product' || confirmModal === 'addon' && 'Optional Services'}?</p>
                                    <div className="d-flex justify-content-between mt-4">
                                        <button className="btn btn-outline-primary px-5" type="button" onClick={() => { setConfirmModal(false) }}>No</button>
                                        <button className="btn btn-primary px-5" type="button" onClick={() => { confirmModal === 'addon' && dispatch(setSelectedAddOns(emiData?.cross_sell_detail)); dispatch(setUserAddOnDetails(emiData?.nominee_detail)); dispatch(setHdfcAddOnDetails(emiData?.hdfc_data)); dispatch(setSubStage(confirmModal)); setConfirmModal(false) }}>Yes</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            }
        </>
    )
}

export default DoSummary;